import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { useMemo } from "react";

const useInterventionGroupAccess = (interventionGroupId: any) => {
    const { intGrpIDsWithReadAccess, intGrpIDsWithEditAccess } = useSelector<
        ApplicationState,
        ApplicationState["cases"]
      >((s) => s.cases);

    
    let isIntGrpIDsWithReadAccess = useMemo(() => {
        if(intGrpIDsWithReadAccess?.length) {
            return intGrpIDsWithReadAccess?.includes(interventionGroupId);
        }
    },[intGrpIDsWithReadAccess]);

    return {
        isIntGrpIDsWithReadAccess
    }
}

export default useInterventionGroupAccess;